export default {
  title: 'Liefersoft',
  form: {
    company_id: 'ID companie',
    login: 'Autentificare',
    password: 'Parolă',
  },
  buttons: {
    save: 'Salvează',
    edit: 'Editează',
    cancel: 'Anulează',
  },
  toasts: {
    error: 'Salvarea modificărilor a eșuat',
    success: 'Modificările au fost salvate',
  },
  instructions: {
    title: 'Instrucțiuni de configurare:',
    steps: {
      1: 'Mergeți la „Setări" > „Setări program" > „API/Interfețe".',
      2: 'Adăugați o platformă:\n• Faceți clic pe butonul „Platforme".\n• Introduceți un nume de utilizator (ex.: numele platformei).\n• Faceți clic pe „Salvează".',
      3: 'Copiați datele API:\n• După salvare, va apărea o fereastră cu codul platformei API.\n• Copiați datele afișate.',
    },
  },
  connected: {
    title: 'Liefersoft este conectat',
    description: 'Această integrare este configurată.',
  },
};
